export const CONCEPTS_LIST_PAGE_LIMIT = 10
export const CONTRACT_LIST_PAGE_LIMIT = 10
